import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navCategories, siteInfo } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline"
          >
            <span className="text-xl md:text-2xl font-heading font-bold whitespace-nowrap">
              <span className="text-primary-500">51</span>黑料吃瓜网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-full hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors duration-200 whitespace-nowrap"
            >
              关于我们
            </Link>
            <button className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors duration-200 cursor-pointer">
              <i className="ri-search-line text-lg text-foreground-700"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          >
            <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-6 py-4">
          <div className="flex flex-col gap-1">
            {navCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors duration-200"
              >
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-200/60 my-2"></div>
            <Link
              to="/about"
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-foreground-950 rounded-lg transition-colors duration-200"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}